export default __webpack_public_path__ + "static/media/volume_icon.82a2fcfe.svg";